var exports = {
  "e6": "ChannelItem.module__channelItemCore___WENTRG",
  "$H": "ChannelItem.module__channelItemCoreSelected___WENTRG",
  "_B": "ChannelItem.module__channelItemCoreUnselected___WENTRG",
  "Vp": "ChannelItem.module__channelItemCoreHovered___WENTRG",
  "TV": "ChannelItem.module__typingTooltip___WENTRG",
  "kp": "ChannelItem.module__channelTypingIndicator___WENTRG",
  "IM": "ChannelItem.module__typingIndicatorIcon___WENTRG",
  "U4": "ChannelItem.module__channelItemSelected___WENTRG",
  "OI": "ChannelItem.module__typingAvatars___WENTRG",
  "_N": "ChannelItem.module__channelItemIcon___WENTRG",
  "Jz": "ChannelItem.module__channelItemIconSelected___WENTRG",
  "Wk": "ChannelItem.module__categoryContainer___WENTRG",
  "yb": "ChannelItem.module__categoryName___WENTRG",
  "zc": "ChannelItem.module__iconContainer___WENTRG",
  "HA": "ChannelItem.module__channelName___WENTRG",
  "Hq": "ChannelItem.module__actionsContainer___WENTRG",
  "OO": "ChannelItem.module__channelItemIconUnselected___WENTRG",
  "Cr": "ChannelItem.module__channelItemIconHighlight___WENTRG",
  "rC": "ChannelItem.module__channelItemLabel___WENTRG",
  "gw": "ChannelItem.module__channelItemActions___WENTRG",
  "kL": "ChannelItem.module__container___WENTRG",
  "YI": "ChannelItem.module__channelReorderTarget___WENTRG",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___WENTRG",
  "XE": "ChannelItem.module__unreadIndicator___WENTRG",
  "_j": "ChannelItem.module__unreadIndicatorMuted___WENTRG",
  "fc": "ChannelItem.module__channelItem___WENTRG",
  "Z$": "ChannelItem.module__channelItemCategory___WENTRG",
  "RQ": "ChannelItem.module__channelItemRegular___WENTRG",
  "zx": "ChannelItem.module__channelItemHighlight___WENTRG",
  "_R": "ChannelItem.module__channelItemMuted___WENTRG",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___WENTRG",
  "Fb": "ChannelItem.module__channelItemHoverable___WENTRG",
  "FN": "ChannelItem.module__channelItemPressed___WENTRG",
  "Je": "ChannelItem.module__channelItemOver___WENTRG",
  "X9": "ChannelItem.module__channelItemContextMenu___WENTRG",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___WENTRG",
  "GJ": "ChannelItem.module__channelItemDragging___WENTRG",
  "rO": "ChannelItem.module__channelItemDimmed___WENTRG",
  "x1": "ChannelItem.module__channelItemMutedState___WENTRG",
  "Ef": "ChannelItem.module__hoverAffordance___WENTRG",
  "Mn": "ChannelItem.module__keyboardFocus___WENTRG",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___WENTRG",
  "Yq": "ChannelItem.module__categoryContent___WENTRG",
  "Yl": "ChannelItem.module__categoryIcon___WENTRG",
  "Sk": "ChannelItem.module__createChannelButton___WENTRG",
  "$Z": "ChannelItem.module__createChannelIcon___WENTRG",
  "Ne": "ChannelItem.module__voiceUserCount___WENTRG",
  "p9": "ChannelItem.module__channelItemVoice___WENTRG",
  "pL": "ChannelItem.module__contextMenuOpen___WENTRG",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___WENTRG",
};

module.exports = exports;
